import { Component, OnInit } from '@angular/core';
import { AbstractCalculatorComponentEmitsValue } from '../abstract-calculator-component-emits-value.directive';
import { SelectOption } from '../../../../inputs/select/model/select-option';

@Component({
  selector: 'psc-calculator-supplier-selector',
  templateUrl: './calculator-supplier-selector.component.html',
})
export class CalculatorSupplierSelectorComponent extends AbstractCalculatorComponentEmitsValue implements OnInit {
  loadingSuppliers: boolean;
  supplierOptions: SelectOption[] = [];
  supplierDisabled: boolean = true;


  get controlName(): string {
    return 'supplier';
  }

  override ngOnInit() {
    super.ngOnInit();

    this.subs.sink = this.manager.country.subscribe((value) => {
      this.control?.reset();
      console.log("country")
      this.supplierDisabled = true;
      if (!value) {
        return;
      }
      this.loadingSuppliers = true;
      this.priceService.getSuppliers(value, this.getCalculatorPrivacyStatus()).subscribe((value) => {
        this.supplierOptions = value.map((supplier) =>
          ({ label: supplier.name, value: supplier.name }));
        if (!this.advanced) {
          this.control?.setValue(this.supplierOptions[0].value);
        }
        this.supplierDisabled = false;
      }).add(() => {
        this.loadingSuppliers = false;
      });
    });
  }

}
